import React from "react";
import { colors } from "../../../../themes/Colors";
import { BaseButtons, IconOnlyButton } from "../../../common-components";

const LandingCard = ({
  display,
  info,
  info2,
  onNextClick,
  onRegClick,
  imageHeight,
  imageWidth,
  cardImage,
  cardtitle,
  width,
  shortText,
  subTitle,
  backgroundColorButton,
  editorDisplay,
  index,
}) => {
  return (
    <div
      key={index}
      style={{
        height: "100%",
        width: display ? "100%" : 0,
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transition: "all 0.3s",
        // opacity: display ? 1 : 0,
      }}
    >
      <div
        style={{
          height: width > 599 ? "70%" : "80%",
          width: "80%",
          maxWidth: editorDisplay ? 700 : width > 599 ? 900 : 300,
          minWidth: editorDisplay ? 700 : width > 599 ? 900 : 300,
          minHeight: 250,
          maxHeight: editorDisplay ? 300 : width > 599 ? 390 : 450,
          borderRadius: 20,
          backgroundColor: colors.secondaryGrey,
          borderStyle: "solid",
          borderColor: colors.white,
          borderWidth: 3,
          WebkitBoxShadow: "-2px 20px 40px -10px #000000",
          marginTop: width > 599 ? 40 : 70,
          display: "flex",
          position: "relative",
          justifyContent: "center",
          alignContent: "center",
          //   overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            left: -100,
          }}
        >
          {/* <IconOnlyButton
            onClick={onLeftClick}
            height={75}
            width={75}
            iconImage={require("../../../../images/icons/greyLeftArrow.png")}
          /> */}
        </div>
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: width > 599 ? "row" : "column",
          }}
        >
          <div
            style={{
              flex: 0.5,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              width: "100%",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: editorDisplay ? -120 : width > 599 ? -90 : -50,
              }}
            >
              <img
                alt="pic"
                src={cardImage}
                style={{
                  height: editorDisplay ? imageHeight - 50 : imageHeight,
                  width: editorDisplay ? imageWidth - 50 : imageWidth,
                }}
              />
            </div>

            <div
              style={{
                fontSize: editorDisplay ? 30 : width > 599 ? 38 : 20,
                color: colors.secondaryDarkBlue,
                marginTop: width > 599 ? 140 : 75,
                marginBottom: 10,
                fontWeight: "bold",
                width:
                  width > 599 ? "80%" : shortText.length > 60 ? "90%" : "90%",
                textAlign: "left",
              }}
            >
              {cardtitle}
            </div>
            <div
              style={{
                fontSize: editorDisplay
                  ? 16
                  : width > 599
                  ? shortText.length > 60
                    ? 20
                    : 28
                  : 14,
                color: colors.secondaryDarkBlue,
                marginBottom: width > 599 ? 80 : 0,
                //   fontWeight: "bold",
                width:
                  width > 599 ? "80%" : shortText.length > 60 ? "90%" : "90%",
                textAlign: "left",
                // borderStyle: "solid",
              }}
            >
              {shortText}
            </div>
          </div>
          <div
            style={{
              flex: 0.5,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
              width: "100%",
              position: width > 599 ? "relative" : null,
            }}
          >
            <div
              style={{
                width: "90%",
                flex: 1,
                fontSize: width > 599 ? 16 : 12,
                display: "flex",
                flexDirection: "column",
                justifyContent: width > 599 ? "center" : "flex-start",
                alignItems: "center",
              }}
            >
              {" "}
              <div
                style={{
                  width: "100%",
                  marginBottom: 10,
                  marginTop: width > 599 ? 30 : 10,
                  fontSize: editorDisplay ? 18 : width > 599 ? 22 : 16,
                  fontWeight: "bold",
                  opacity: 0.7,
                  textAlign: "left",
                }}
              >
                {subTitle}
              </div>
              <div
                style={{
                  fontSize: editorDisplay
                    ? 12
                    : info && !info2
                    ? width > 599
                      ? 22
                      : 16
                    : width > 599
                    ? 16
                    : 12,
                }}
              >
                {info}
              </div>
              <div style={{ height: 10 }} />
              <div
                style={{
                  fontSize: editorDisplay
                    ? 12
                    : info && !info2
                    ? width > 599
                      ? 22
                      : 16
                    : width > 599
                    ? 16
                    : 12,
                }}
              >
                {info2 === "none" ? null : info2}
              </div>
              <div style={{ height: width > 599 ? 40 : 50 }} />
            </div>
            <div
              style={{
                width: "90%",
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                marginBottom: width > 599 ? 20 : 10,
                marginTop: width > 599 ? 0 : 10,
                position: width > 599 ? "absolute" : "absolute",
                bottom: width > 599 ? -50 : -40,
              }}
            >
              <IconOnlyButton
                widthScreen={width}
                iconImage={require("../../../../images/icons/profileWhite.png")}
                height={width > 599 ? 55 : 60}
                width={width > 599 ? 55 : 60}
                // label={"REGISTER"}
                marginRight={10}
                labelColor={colors.white}
                backgroundColor={backgroundColorButton}
                borderRadius={"100%"}
                shadow={true}
                onClick={onRegClick}
              />

              <IconOnlyButton
                widthScreen={width}
                iconImage={require("../../../../images/icons/infoWhite.png")}
                height={width > 599 ? 55 : 60}
                width={width > 599 ? 55 : 60}
                // label={"MORE INFO"}
                marginRight={10}
                labelColor={colors.white}
                backgroundColor={backgroundColorButton}
                borderRadius={"100%"}
                shadow={true}
              />

              <IconOnlyButton
                widthScreen={width}
                iconImage={require("../../../../images/icons/greyArrowRight.png")}
                height={width > 599 ? 55 : 60}
                width={width > 599 ? 55 : 60}
                // label={"NEXT"}
                onClick={onNextClick}
                labelColor={colors.white}
                backgroundColor={backgroundColorButton}
                borderRadius={"100%"}
                shadow={true}
              />
              {/* <BaseButtons
                label={"BUTTON"}
                borderRadius={10}
                width={"100%"}
                backgroundColor={backgroundColorButton}
              /> */}
            </div>
          </div>
        </div>
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            position: "absolute",
            right: width > 599 ? -100 : -20,
            bottom: width > 599 ? null : -250,
          }}
        >
          {/* {width > 599 ? (
            <div
              style={{
                borderRadius: 100,
                position: "relative",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                paddingBottom: 1,
              }}
            >
              <IconOnlyButton
                onClick={onRightClick}
                height={75}
                width={75}
                iconImage={require("../../../../images/icons/greyArrowRight.png")}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: -30,
                  color: colors.white,
                  fontWeight: "bold",
                }}
              >
                Next
              </div>
            </div>
          ) : (
            <div
              style={{
                backgroundColor: colors.secondaryDarkBlue,
                borderRadius: 100,
                position: "relative",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                paddingBottom: 1,
              }}
            >
              <IconOnlyButton
                onClick={onRightClick}
                height={60}
                width={60}
                iconImage={require("../../../../images/icons/greyArrowRight.png")}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: -20,
                  color: colors.white,
                  fontWeight: "bold",
                }}
              >
                Next
              </div>
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default LandingCard;
